// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1747187660883
      var cssReload = require("D:/word/aiks-big-screen-v1-shanxi/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  